// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const ConfigurationDefaultPricingMethodValues = [
	"BOM",
	"CONSTANT_PRICE",
	"PRICE_SCRIPT",
	"COST_WITH_PROFIT",
	"BOM_PRICE_PLUS_LABOUR_COST_WITH_PROFIT",
] as const;

export type ConfigurationDefaultPricingMethod = (typeof ConfigurationDefaultPricingMethodValues)[number];

export const getConfigurationDefaultPricingMethodLabels = () => ({
	BOM: t("bom"),
	CONSTANT_PRICE: t("constant_price"),
	PRICE_SCRIPT: t("price_script"),
	COST_WITH_PROFIT: t("cost_with_profit"),
	BOM_PRICE_PLUS_LABOUR_COST_WITH_PROFIT: t("bom_price_plus_labour_cost_with_profit"),
});

export const getConfigurationDefaultPricingMethodLabel = (value: ConfigurationDefaultPricingMethod): string => {
	return getConfigurationDefaultPricingMethodLabels()[value];
};
